export const connectionStatus = [
  { code: 0, label: 'disconnected', color: 'error', ripple: '', icon: 'ic:round-change-circle', action: 'reconnect'},
  { code: 1, label: 'connected', color: 'success', ripple: 'green', icon: 'ic:round-circle', action: ''},
  { code: 2, label: 'reconnecting', color: 'warning', ripple: 'yellow', icon: 'ic:round-circle', action: ''},
];